import type { IconOption } from '@/components/IconPicker'

// Curated set offered by the category Icon picker. Every `name` must be a valid
// lucide-react dynamic icon name (see categoryIcon.tsx) — kept small and
// finance/household-relevant rather than exposing all ~1900 lucide icons, which would
// make the picker unusable. A category saved before the picker existed may still carry
// an icon outside this list (free-typed, or an emoji); CategoryIcon renders those fine,
// they're just not offered as a choice going forward.
export const CATEGORY_ICON_OPTIONS: IconOption[] = [
  { name: 'utensils', label: 'Food & Dining' },
  { name: 'shopping-cart', label: 'Groceries' },
  { name: 'shopping-bag', label: 'Shopping' },
  { name: 'coffee', label: 'Coffee & Snacks' },
  { name: 'car', label: 'Transport' },
  { name: 'fuel', label: 'Fuel' },
  { name: 'bus', label: 'Public Transport' },
  { name: 'bike', label: 'Bike' },
  { name: 'plane', label: 'Travel' },
  { name: 'home', label: 'Rent / Home' },
  { name: 'zap', label: 'Electricity' },
  { name: 'droplet', label: 'Water' },
  { name: 'wifi', label: 'Internet' },
  { name: 'phone', label: 'Phone / Mobile' },
  { name: 'tv', label: 'Entertainment' },
  { name: 'film', label: 'Movies' },
  { name: 'music', label: 'Music & Subscriptions' },
  { name: 'gamepad-2', label: 'Gaming' },
  { name: 'dumbbell', label: 'Fitness' },
  { name: 'heart-pulse', label: 'Health' },
  { name: 'pill', label: 'Medicine' },
  { name: 'stethoscope', label: 'Doctor' },
  { name: 'graduation-cap', label: 'Education' },
  { name: 'book-open', label: 'Books' },
  { name: 'baby', label: 'Kids' },
  { name: 'paw-print', label: 'Pets' },
  { name: 'shirt', label: 'Clothing' },
  { name: 'scissors', label: 'Personal Care' },
  { name: 'gift', label: 'Gifts' },
  { name: 'briefcase', label: 'Work / Business' },
  { name: 'wallet', label: 'Salary / Income' },
  { name: 'banknote', label: 'Cash' },
  { name: 'piggy-bank', label: 'Savings' },
  { name: 'trending-up', label: 'Investments' },
  { name: 'landmark', label: 'Bank' },
  { name: 'credit-card', label: 'Credit Card' },
  { name: 'receipt', label: 'Bills' },
  { name: 'wrench', label: 'Maintenance' },
  { name: 'umbrella', label: 'Insurance' },
  { name: 'hand-heart', label: 'Charity' },
  { name: 'users', label: 'Family' },
  { name: 'tag', label: 'Other' },
]
